export default __webpack_public_path__ + "static/media/tour-access-code-success.83278302.svg";